import { getWidgetConfig } from '../config'

let globalPrefix = 'AIQ'
let globalSuffix = ''

export function setGlobalPrefix(prefix: string): void {
  globalPrefix = prefix
}

export function getGlobalPrefix(): string {
  return globalPrefix
}

export function setGlobalSuffix(suffix: string): void {
  globalSuffix = suffix
}

export function getGlobalSuffix(): string {
  return globalSuffix
}

/** True when widget config, ?debug=true, or localStorage aiq-debug=true is set. */
export function isDebugEnabled(): boolean {
  try {
    return (
      getWidgetConfig()?.debug === true ||
      window.location.search.includes('debug=true') ||
      localStorage.getItem('aiq-debug') === 'true'
    )
  } catch {
    return false
  }
}

const STYLES = {
  log: 'color: #00a67c; font-weight: bold',
  info: 'color: #007bff; font-weight: bold',
  warn: 'color: #ffc107; font-weight: bold',
  error: 'color: #dc3545; font-weight: bold',
  success: 'color: #28a745; font-weight: bold',
}

class Logger {
  private print(type: keyof typeof STYLES, message: string, ...args: unknown[]) {
    const prefix = globalPrefix ? `[${globalPrefix}]` : ''
    const suffix = globalSuffix ? ` ${globalSuffix}` : ''
    const style = STYLES[type]

    if (isDebugEnabled()) {
      console.log(`%c${prefix}%c ${message} ${suffix}`, style, 'color: inherit', ...args)
    }
  }

  log(message: string, ...args: unknown[]) {
    this.print('log', message, ...args)
  }

  info(message: string, ...args: unknown[]) {
    this.print('info', message, ...args)
  }

  warn(message: string, ...args: unknown[]) {
    this.print('warn', message, ...args)
  }

  error(message: string, ...args: unknown[]) {
    this.print('error', message, ...args)
  }
}

export const logger = new Logger()

// Standalone exports
export const log = logger.log.bind(logger)
export const info = logger.info.bind(logger)
export const warn = logger.warn.bind(logger)
export const error = logger.error.bind(logger)
